import React from 'react';

export const agreeInfo1 = () =>
<div style={{ backgroundColor:'#fff' , padding: '10px', borderRadius: '4px', border: '1px solid rgb(221, 221, 221)', borderImage: 'none', width: '100%', height: '100px', textAlign: 'left', lineHeight: '1.5', overflow: 'auto', fontSize: '12px' }}>
    "성공하세요" 인터넷장부 서비스 이용 약관<br/><br/>
    온라인 이용 약관과 업무처리규칙 및 SLA(서비스수준협약)(이하 “약관” )은 ㈜성공하는사람들 (이하 “자사” )가 제공하는 제품, 소프트웨어, 인적 서비스, 기능 등(이하 “서비스” )을 자사의 온라인 경영관리시스템인 www.성공하세요.com 웹사이트(이하 “서비스 웹사이트”) 상에서 이용하고자 본 약관에 동의하는 주체(“고객”) 간 의무와 권리 및 책임사항을 정하고 있습니다.<br/><br/>
    제1조(약관의 효력)<br/><br/>
    
    1. 본 약관은 온라인 이용약관과 업무처리규칙 및 SLA로 구성되며 고객이 서비스에 가입 후 이용료 결제 완료 하면 자동으로 효력을 발생합니다.<br/><br/>
    
    2. 고객이 대리인(가족, 고용인을 포함하되, 이에 한하지 않음)를 통하여 약관에 동의하고 가입신청 하는 경우에도 대리인은 계약상, 법률상 고객을 대리할 정당한 권한을 보유 하였음을 보증하고, 고객은 약관에 동의하고 준수할 것임을 보증합니다.<br/><br/>
    
    3. 고객이 약관에 동의하는 것은 고객의 고용인들과 지점, 관계사, 협력사, 거래처 등 고객으로 인해 본 서비스를 이용하는 모든 사용자로 하여금 본 약관을 준수하게 할 책임이 있다는 것을 의미합니다.<br/><br/><br/>
    
    
    
    제2조(약관의 변경)<br/><br/>
    
    1. 자사는 약관을 수시로 변경할 수 있으며, 변경된 약관의 효력발생일을 명기하여 서비스 웹사이트에 게재하며, 명기된 효력발생일로부터 변경된 약관이 적용됩니다.<br/><br/>
    
    2. 고객은 서비스를 계속 이용함으로써 변경된 약관에 동의하는 것으로 간주합니다. 다만, 고객에게 현저히 불리하게 변경된 약관의 내용은 고객에게 이메일 등의 전자적 수단으로 개별 통지하며, 통지한 날로부터 3일 이내에 고객이 이의를 제기하지 않거나 통지한 이후에도 서비스를 계속 이용하면 변경된 약관에 동의한 것으로 간주합니다.<br/><br/>
    <br/>
    
    
    제3조(무료 체험)<br/><br/>
    
    1. 고객이 무료 체험 버전을 사용하는 경우에도 본 약관은 동일하게 적용되며, 기술상 정책상 일부 기능이 제한될 수 있습니다.<br/><br/>
    
    2. 자사는 무료 체험 버전에 대한 서비스 제공을 언제든지 중단할 수 있습니다.<br/><br/>
    
    3. 고객은 무료 체험 버전 사용 기간 중 입력한 데이터 및 생성한 설정 일체에 접속하거나 회수, 재사용할 수 없습니다.<br/><br/><br/>
    
    
    
    제4조(서비스)<br/><br/>
    
    1. 서비스는 자사가 운용하는 인터넷 상의 서비스 웹사이트를 기반으로 제공되며, 또한 공중망(인터넷을 통한 네트워크 서비스)을 통해서만 제공합니다.<br/><br/>
    
    2. 서비스는 특정 인터넷 브라우저와 버전을 기준으로 제공되며 브라우저와 버전은 기술 상 필요에 따라 변경될 수 있습니다. 기준 외의 브라우저나 버전에서는 서비스의 일부 또는 전체가 구동하지 않을 수 있습니다.<br/><br/>
    <br/><br/>
    3. 자사는 기술적 정책적 판단에 의해 언제든지 서비스를 수정(신규 기능과 절차의 추가, 기존 기능과 절차의 변경과 삭제를 포함하되, 이에 한하지 않음)할 수 있습니다. 다만, 자사가 서비스의 중요한 수정이라고 판단할 경우, 서비스 웹사이트 메인 화면에 수정 내역을 게시함으로써 고객에게 공지할 수 있습니다.
    <br/><br/>
    4. 서비스의 수정은 정기적 또는 비정기적으로 발생할 수 있습니다. 
    <br/><br/>
    5. 고객은 고객에게 필요한 기능과 절차에 대해 언제라도 자사에 제안하거나 아이디어를 제공할 수 있으나, 자사는 고객들의 해당 기능 개발 요청 빈도, 개발의 가능성, 방향성, 그리고 적합성 등을 기준으로 개발 여부를 재량으로 판단합니다.
    <br/><br/>
    6. 자사는 경영, 재무, 회계, 세무 또는 기타 전문 영역에 관한 자문을 별도 부가서비스로 제공합니다. 상기 종류의 도움이 필요할 경우 고객은 자사에게 별도 부가서비스를 신청해야 합니다.
    <br/><br/><br/>
    
    
    제5조(모바일 기기에서의 서비스 사용)
    <br/><br/>
    1. 서비스는 인터넷을 통해 사용하는 호환성 있는 모바일 기기에서 사용이 가능합니다. 고객은 고객의 모바일 기기 및 통신사의 약관 조항과 일반 사용법, 서비스의 업데이트 등 모든 변경 사항에 대해 스스로 책임을 집니다.
    <br/><br/>
    2. 자사는 자사의 귀책 사유가 없는 서비스 장애 상황 등(다음 사항을 포함하되, 이에 한하지 않음)에 대해 어떠한 책임도 지지 않습니다.
    <br/><br/>
    • 고객 통신서비스 제공사의 서비스 제공 가능 여부
    <br/>
    • 시간 및 장소를 불문한 서비스 접속 가능 여부
    <br/>
    • 통신서비스 관련 서비스 일체의 누락, 손상 또는 보안 침해
    <br/>
    • 데이터 정보 전송 실패 또는 서비스 연결 설정 실패
    <br/>
    • 제 3자의 정보 누설
    <br/><br/><br/>
    제6조(데이터 보호 및 관리)
    <br/><br/>
    1. 데이터란 고객이 입력하여 물리적인 서버 내에 저장된 자료입니다.
    <br/><br/>
    2. 자사는 고객 데이터의 보안과 무결성을 보호하며 고객 데이터에 대한 허락 받지 않은 접근을 방지하기 위해 최소 업계 표준 시스템 및 절차를 구현했습니다.
    <br/><br/>
    3. 고객의 데이터는 자사 또는 자사 대리인이 시설을 유지 관리하는 지역 또는 국가에 저장하고 연산 처리할 수 있습니다.
    <br/><br/>
    4. 자사는 수사기관의 영장, 법원의 판결 또는 결정 또는 정당한 법률에 의거한 경우에는 고객의 데이터를 요청기관에 고객에 대한 사전 통지 없이 제공하거나 공개할 수 있습니다.
    <br/><br/><br/>
    
    
    제7조(콘텐츠)<br/><br/>
    
    1. 콘텐츠란 고객이 서비스 이용 중 서비스 웹사이트에 업로드하거나 게시 또는 저장한 일체의 자료(데이터, 게시글, 소프트웨어, 음악, 소리, 사진, 그래픽, 비디오, 메시지를 포함하되, 이에 한하지 않음) 및 그 자료들의 결합, 변형 또는 재연산을 통해 생성되는 부가 자료 일체입니다.
    <br/><br/>
    2. 고객의 실수나 관리소홀로 인해 분실되거나 복구 불가능한 콘텐츠 일체에 대한 책임은 고객에게 있으며, 자사는 콘텐츠에 대한 관리 의무가 있습니다.
    <br/><br/>
    3. 고객은 다음 사항에 포함되는 콘텐츠를 업로드, 게시, 배포, 링크, 출판, 재생산 또는 전송하지 않을 것이며, 제 3자에게 이를 허용하지 않을 것임을 동의하며, 다음 사항의 콘텐츠가 게재될 경우 자사는 판단에 따라 해당 콘텐츠를 즉시 삭제할 수 있다.
    <br/><br/>
    • 불법, 사기, 명예 훼손, 외설, 포르노, 비속어, 협박, 증오, 희롱, 모욕 및 부적절하거나 불쾌한 정보 또는 통신 일체를 포함하며, 꼭 언급한 내용이 아니더라도 타인을 격분하게 만들 수 있는 내용 일체 및 법적 형사 또는 민사책임이 적용되는 내용 일체
    <br/>
    • 타인을 사칭하거나 고객의 신분 또는 자격을 거짓 증명하는 내용 및 개인 사생활 일체를 침해할 수 있는 내용
    <br/>
    • 호객 행위, 투자 기회, 다단계 판매, 단체 문자(SMS), 스팸메일 등 제 3자가 원치 않는 상업적 자료
    <br/>
    • 바이러스, 트로이 목마, 웜 또는 기타 파괴성 있는 악성 소프트웨어와 자료
    <br/>
    • 고객이 법적인 권리를 지니지 않거나 저작권자 또는 지적재산권자의 허가를 받지 않은 정보 및 소프트웨어 일체
    <br/><br/>
    4. 자사는 제안사항, 상담문의 및 내역, 아이디어 등 고객이 작성한 콘텐츠를 서비스 개선을 위해 어떠한 형태로든 자유롭게 사용(서비스 개선 아이디어 및 광고 마케팅 자료 활용 등을 포함하며, 이에 한하지 않음)할 수 있으며, 자사는 고객이 제공한 콘텐츠 일체에 관해 영구적이고 전세계적으로 사용할 수 있고, 전면 양도 및 2차 인가가 가능하며, 고객은 자사에 제공한 콘텐츠에 대하여 로열티 등의 일체 비용을 요구할 수 없습니다.
    <br/><br/>
    5. 자사는 자사와 고객을 보호하거나 서비스를 정상적으로 운영하기 위해 콘텐츠 일체를 감시 또는 수집할 수 있습니다.
    <br/><br/>
    6. 자사는 자사 재량에 의해 허용되지 않거나 바람직하지 않은 콘텐츠, 또는 부적절하거나 본 약관을 위반하는 콘텐츠 일체의 게시 및 저장을 거부하거나 삭제, 또는 삭제를 거부할 수 있습니다.
    <br/><br/><br/>
    
    
    제8조(커뮤니티 사이트)<br/><br/>
    
    1. 자사 서비스에는 서비스 이용자 및 대중이 정보를 교환할 수 있는 블로그, 카페, 포럼, 지식Q&amp;A 게시판, SNS(이하 “커뮤니티 사이트”) 등이 포함되어 있을 수 있습니다. 
    <br/><br/>
    2. 자사는 타 이용자들이 커뮤니티 사이트에 게재하는 콘텐츠의 정확성에 대해 책임지지 않습니다.
    <br/><br/>
    3. 커뮤니티 사이트에서 고객이 게재한 콘텐츠는 사용자들이 제 3자가 운영하는 사이트에 퍼가기 하거나 하이퍼링크를 걸 수 있으며 자사는 이에 대해 책임을 지지 않습니다.
    <br/><br/>
    4. 본 조 제1항 내지 제3항에도 불구하고, 커뮤니티 사이트에 특정 개인이나 법인의 명예 또는 신용을 심각하게 훼손하는 등 공익에 반하거나 공서양속에 반하는 콘텐츠가 게재될 경우, 자사는 재량으로 또는 특정 개인이나 법인의 요청에 따라 콘텐츠를 삭제할 수 있습니다
    <br/><br/>
    5. 커뮤니티 사이트에서 타 참여자들에게 제공되는 콘텐츠 일체는 커뮤니티 사이트들의 서비스 이용 약관 및 개인정보 취급방침의 내용을 적용 받습니다.
    <br/><br/><br/>
    
    
    제9조(정보의 제공 및 광고의 게재)
    <br/><br/>
    1. 정보란 고객이 제공, 노출하였거나 자사에 의해 파악된 고객의 자료(고객 자신, 서비스 사용 경험, 고객의 비즈니스, 기타) 일체입니다.
    <br/><br/>
    2. 자사가 정보에 대하여 재가공하거나, 제 3자와 공유하거나 출판, 배포할 수 있는 권한을 가지고 서비스 개선에 활용하는 권한을 가지는 것에 대해 고객은 동의합니다.
    <br/><br/>
    3. 자사는 고객에게 자사의 다른 서비스, 제품 또는 광고를 제공할 수 있으며, 이때 추가적인 약관 및 요금이 적용될 수 있습니다.
    <br/><br/>
    4. 자사는 서비스 사용에 도움을 줄 수 있는 부가 서비스 또는 제 3자 제품에 관한 내용을 고객에게 전달할 수 있습니다. 고객은 자사가 상기 내용들을 이메일로 전송하거나 서비스 웹사이트에 게시하는 것에 동의합니다.
    <br/><br/><br/>
    
    
    제10조(결제 및 지불)
    <br/><br/>
    1. 결제: 고객은 매월 또는 연 단위로 자사 서비스를 결제해야 합니다.
    <br/><br/>
    2. 환불: 연 선납 고객이 중도 해지하는 경우, 선납 결제한 금액 중 서비스 해지 이후의 기간에 해당하는 미경과 금액을 비율로 환산하여 환불합니다. 매월 납부 고객의 경우, 서비스 시작 월의 잔여기간에 대해 비용납부 의무가 없으며, 해지 월의 잔여기간에 대해서도 환불을 요청하지 않는다는데 동의합니다. 환불과정에서 발생하는 제반 수수료, 비용 등은 고객이 부담합니다.
    <br/><br/>
    3. 결제방법: 별도로 합의하지 않는 한 고객은 자사가 지정한 결제수단과 화폐단위로 결제합니다.
    <br/><br/>
    4. 세금포함: 고객이 서비스 이용과 관련된 세금(부가가치세를 포함하되, 이에 한하지 않음)에 대해 책임을 지므로, 고객은 서비스에 대해 세금까지 포함하여 자사에 지불해야 합니다.
    <br/><br/>
    5. 원천징수: 결제금액은 은행, 카드사, 결제대행사(Payment Gateway) 등 자사가 지정한 방법을 통해 자사에 최종 도달한 금액을 기준으로 하며 해당 결제를 위해 고객 국가의 세무 당국에 지급하여야 할 금액은 고객이 부담합니다.
    <br/><br/><br/>
    
    
    제11조(해지 및 종료)
    <br/><br/>
    1. 결제일 또는 데이터등록권 만료일 중 이후 날짜 기준 6개월이 지나면 고객의 데이터 및 계정은 휴면계정으로 전환됩니다.
    <br/><br/>
    2. 고객의 의사로 인한 해지: 고객은 서비스 이용 중 언제든지 서비스를 해지할 수 있습니다.
    <br/><br/>
    3. 자사의 의사로 인한 해지: 자사는 언제든지 어떠한 이유에서든 서비스를 해지할 수 있습니다. 이 경우 최소 30일 전에 고객에게 안내합니다. 안내는 이메일 또는 메인화면에 내용을 게시하는 방식으로 합니다. 다만, 고객이 약관을 위반한 경우에 즉시 해지할 수 있습니다.
    <br/><br/>
    4. 고객 데이터 백업: 고객은 종료나 해지 전에 데이터를 백업할 수 있습니다. 자사가 제공하는 백업 수단은 기술 상 혹은 정책 상 고객의 모든 데이터에 대한 완전한 백업을 의미하지는 않습니다.
    <br/><br/>
    5. 해지 이후 데이터: 자사는 해지한 고객이나 이용이 종료된 고객의 데이터를 보관할 의무가 없으며, 통상적으로 해지나 종료한 날로부터 6개월이 지난 종전 고객 데이터는 삭제하는 것을 내부방침으로 합니다.
    <br/><br/>
    6. 휴면계정 데이터: 휴면계정 전환 후 6개월이 지난 시점에서 데이터는 삭제 처리되며, 휴면계정의 데이터에 한하여 당사는 책임 및 의무를 가지지 않습니다.
    <br/><br/>
    7. 휴면계정 해지방법 : 별도의 부가서비스(휴면계정해지 신청) 을 통하여 수수료(계정당 10만원) 지급 후 데이터를 복구 할 수 있습니다. 휴면계정 전환 기간이 길어질 경우 모든 데이터 정상복구는 불가능 할 수 있습니다.
    <br/><br/><br/>
    
    
    제12조(일시 중지)
    <br/><br/>
    1. 고객이 약관 및 업무처리규칙을 위반하거나, 자료의 소유권을 두고 고객 내부의 분쟁이 있을 경우 자사는 고객에게 전자쪽지 등 전자적 수단으로 개별 통지한 후 서비스의 제공을 일시 중지할 수 있습니다.
    <br/><br/>
    2. 자사는 정기적 혹은 비정기적 시스템의 점검, 긴급한 보안 상의 필요, 기타 서비스 제공에 필요하다고 생각할 경우 언제든지 서비스를 일시 중지할 수 있습니다. 일시 중지로 인해 발생한 고객의 어떠한 피해에 대해서도 자사는 배상의무가 없습니다. 다만, 자사의 귀책사유로 서비스가 사전 공지 없이 영업일 기준 3시간 이상 중지되는 서비스 정전이 발생한 경우에는 서비스수준협약[SLA]에 의해 배상합니다.
    <br/><br/><br/>
    
    
    제13조(면책 및 제한)
    <br/><br/>
    1. 불가항력: 고객과 자사 양 당사자는 자연재해, 전쟁 또는 테러, 폭동, 노사문제, 정부 조치, 인터넷 장애 및 서비스 거부(DoS) 공격 등과 같은 당사자의 통제력을 벗어난 조건으로 인해 발생한 약관 불이행에 대해서는 책임을 지지 않습니다.
    <br/><br/>
    2. 배상금액의 제한: 자사는 고객이 자사의 책임을 묻는 사건이 발생하기 전 12개월 동안 고객이 지불한 금액보다 많은 금액을 배상하지 않습니다.
    <br/><br/>
    3. 서비스 이용을 위한 가입 신청은 고객 스스로 서비스의 적합성과 유용성을 판단하여 스스로 결정한 진정한 의사 표시로서, 자사는 서비스가 고객에게 적합하다거나 고객이 거주하는 모든 지역 및 국가의 상황에도 유용하다고 선언한 사실이 없음을 확인합니다.
    <br/><br/><br/>
    
    
    제14조(기타)
    <br/><br/>
    1. 준거법: 본 약관은 대한민국 법률의 적용을 받습니다. 약관으로 인해 또는 이와 관련하여 분쟁이 발생한 경우, 자사와 고객 양 당사자는 대한민국 서울중앙지방법원을 전속적 합의 관할로 하여 분쟁을 해결합니다.
    <br/><br/>
    2. 동의: 고객은 가입 신청함으로써, 온라인 이용약관과 업무처리규칙, SLA 등 모든 문서에 완전히 동의한 것입니다.
    <br/><br/>
    3. 상충하는 조건에 대한 해석: 본 약관 및 자사 업무처리 규칙, SLA 등의 문서 간에 상충하는 부분이 있을 경우, 우선순위는 ① 가격정책이 기재된 웹 페이지, ② 업무처리규칙 ③ SLA, ④ 온라인 이용약관 순으로 합니다.
    <br/><br/><br/>
    
    
    서비스 수준<br/><br/>
    서비스 사용 기간 동안 자사의 서비스 웹 인터페이스는 무중단의 서비스를 제공함을 원칙으로 합니다. 자사의 귀책사유로 서비스 정전이 발생할 경우 고객은 아래에 명시된 보상을 받을 수 있습니다. 본 SLA는 서비스 정전이 발생했을 때 고객이 취할 수 있는 단독적이며 배타적인 구제조치에 대해 설명합니다.
    <br/><br/>
    본 SLA는 자사의 업무상황, 경영환경, 마케팅 전략, 고객정책 등의 변화에 따라 임의로 변경할 수 있으며, 여기에 게재된 SLA의 최신 내용을 숙지하고 준수할 책임은 귀하에게 있습니다.
    <br/><br/><br/>
    
    
    정의<br/><br/>
    
    • 서비스 정전: 고객이 서비스에 접속 자체가 불능인 상태이거나, 접속 후 서비스 기능의 50% 이상이 불능인 상태가, 최소 3시간 이상 지속되는 경우를 의미합니다.
    <br/><br/>
    • 서비스 정전 기간 측정: 자사 서버 측 오류율을 기준으로 하여 측정합니다.
    <br/><br/>
    • SLA 적용 서비스: 자사가 자체로 개발하여 서비스하는 본 서비스만 적용합니다. 자사가 제3자와 연계하여 제공하는 서비스들과 CS, 유저페이는 적용하지 않습니다.
    <br/><br/>
    • 보상: 서비스 정전이 발생한 경우 자사는 무상 서비스 기간으로 보상합니다. 정전 기간 대비 제공되는 보상은 다음과 같습니다.
    <br/>
    고객은 보상을 요청해야 함
    <br/>
    위에 명시된 보상을 받으려면 고객에게 보상을 수령할 수 있는 자격이 발생한 지 30일 내에 고객이 자사에 관련 사실을 서면(이메일 포함)으로 통지해야 합니다. 이 요구사항을 이행하지 못할 경우 고객은 보상을 받을 권리를 상실하게 됩니다.
    <br/><br/><br/>
    
    
    최대 보상
    <br/><br/>
    상기 무상 서비스 기간 표에 따라 1달 동안 발생한 서비스 정전 기간에 대하여 자사가 고객에게 제공할 수 있는 무상 서비스 시간은 최장 7일으로서 고객은 1달 기준으로 무상 서비스 기간 7일을 초과하여 보상 청구할 수 없습니다.
    
    <br/><br/><br/>
    
    SLA 예외사항
    <br/><br/>
    서비스 정전이 ① 약관의 '불가항력' 조항에 설명된 요인에 의해 발생하거나 ② 고객 또는 제3자의 장비 중 어느 한쪽이나 양쪽 모두의 장애(자사의 통제 범위에 속하지 않는 문제)로 인해 발생할 경우 등 자사의 귀책사유가 아는 다른 사유로 발생한 서비스 정전에는 본 SLA가 적용되지 않습니다.
    <br/><br/><br/>
    <br/>
    
    부칙
    <br/><br/>
    1. 본 약관은 2013년 7월 15일부터 적용됩니다.
</div>

export const agreeInfo2 = () =>
    <div style={{ backgroundColor:'#fff' , padding: '10px', borderRadius: '4px', border: '1px solid rgb(221, 221, 221)', borderImage: 'none', width: '100%', height: '100px', textAlign: 'left', lineHeight: '1.5', overflow: 'auto', fontSize: '12px' }}>
        (주)성공하는사람들 (‘www.성공하세요.com’이하 ‘성공하세요닷컴) 은(는) 아래의 목적으로 개인정보를 수집 및 이용하며, 회원의 개인정보를 안전하게 최급하는데 최선을 다합니다.<br/><br/>
        <strong>1. 수집목적</strong><br/>
        - 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 (컨텐츠 제공, 구매 및 요금 결제)<br/>
        - 회원제 서비스 제공, 개인식별, 가입의사 확인<br/>
        - 추후 법정 대리인 본인확인, 분쟁 조정을 위한 기록보존, 불만처리 등 민원처리, 고지사항 전달<br/>
        - 회원탈퇴의사의 확인<br/><br/>
        <strong>2. 수집항목</strong><br/>
        - (필수) 이름, 생년월일, 성별, 아이디, 비밀번호, 별명, 연락처(메일주소, 휴대폰 번호 중 선택), 가입인증정보<br/><br/>
        <strong>3. 보유기간</strong><br/>
        - 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. <br/><br/>
        더 자세한 내용에 대해서는 <a href="/rules/svcRule02.apro" target="_blank" style={{ fontSize: '14px', color: '#06f' }}>개인정보처리방침</a> 을 참고하시기 바랍니다.
        
    </div>

export const agreeInfo3 = () =>
    <div style={{ backgroundColor:'#fff' , padding: '10px', borderRadius: '4px', border: '1px solid rgb(221, 221, 221)', borderImage: 'none', width: '100%', height: '100px', textAlign: 'left', lineHeight: '1.5', overflow: 'auto', fontSize: '12px' }}>
    <p>
		<strong className="titleSt">개인정보의 제3자 제공</strong><br/>
            <br/>
            &lt;(주)성공하는사람들&gt;(‘www.성공하세요.com’이하 ‘성공하세요닷컴) 은(는) 정보주체의 별도 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우 외에는 개인정보를 제3자에게 제공하지 않습니다.<br/>
                <br/>
		   </p>
            <p className="lh6 bs4"><strong className="titleSt">개인정보처리 위탁</strong><br/>
                <br/> ① <em className="emphasis">&lt;(주)성공하는사람들&gt;('성공하세요닷컴')</em>은(는) 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
            <br/><br/>
			<table className="accTable04 noCrsLine tr_nohover" style={{ margin: '0px auto', width: '90%' }} border="0" cellSpacing="0" cellPadding="0" summary="">
				<caption></caption>
				<colgroup>
				<col width="%"/>
				<col width="%"/>
				<col width="%"/>
				<col width="%"/>
				</colgroup>
				<thead>
					<tr>
						<th style={{ borderLeftColor: 'rgb(221, 221, 221)', borderLeftWidth: '1px', borderLeftStyle: 'solid' }}>제공업체</th>
						<th>제공목적</th>
						<th>제공항목</th>
						<th style={{ borderRightColor: 'rgb(221, 221, 221)', borderRightWidth: '1px', borderRightStyle: 'solid' }}>제공기간</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="ac" style={{ borderLeftColor: 'rgb(221, 221, 221)', borderLeftWidth: '1px', borderLeftStyle: 'solid' }}>진일회계법인</td>
						<td rowSpan="4" className="al pl5">세무기장, 세무신고, 회계 컨설팅, 경영컨설팅을 위한 검토, 조정 및 신고 대리</td>
						<td className="al pl5" rowSpan="4">
							성명, 상호(법인명), 사업자등록번호, 주소, 전화번호<br/><br/>
							상행위를 통한 거래정보 (세무조정서비스 및 프리미엄 서비스 신청자에 한함)<br/><br/>
							www.성공하세요.com 에 입력된 접근 허용된 자료 포함
						</td>
						<td className="ac" rowSpan="4">서비스 이용해지시 까지</td>
					</tr>
					<tr>
						<td className="ac" style={{ borderLeftColor: 'rgb(221, 221, 221)', borderLeftWidth: '1px', borderLeftStyle: 'solid' }}>도담세무회계</td>
					</tr>
					<tr>
						<td className="ac" style={{ borderLeftColor: 'rgb(221, 221, 221)', borderLeftWidth: '1px', borderLeftStyle: 'solid' }}>한빛회계법인</td>
					</tr>
					<tr>
						<td className="ac" style={{ borderLeftColor: 'rgb(221, 221, 221)', borderLeftWidth: '1px', borderLeftStyle: 'solid' }}>세무법인knp</td>
					</tr>
				</tbody>
			</table>
            <br/>
            <br/>
		    <p>② <em className="emphasis">&lt;(주)성공하는사람들&gt;('www.성공하세요.com'이하 '성공하세요닷컴')</em>은(는) 위탁계약 체결시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.<br/>
                <br/>③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.<br/><br/><br/>
		    </p>
    </div>


// WEBPACK FOOTER //
// ./src/components/pages/member/joinAgree.js